import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { GlobalMethodsService } from '../../../services/global-methods.service';
import { TranslateConfigService } from 'src/app/services/commons/translate-config.service';
import { FirebaseCrashlytics } from '@capacitor-community/firebase-crashlytics';
// import jsQR from "jsqr";
@Component({
  selector: 'app-scan-qr-web',
  templateUrl: './scan-qr-web.component.html',
  styleUrls: ['./scan-qr-web.component.scss'],
})
export class ScanQrWebComponent implements OnInit {
  public video;
  public canvasElement;
  public canvas;
  public reqAnim;
  public stopCamera: boolean;
  constructor(private modalCtrl: ModalController,
              public gms: GlobalMethodsService,
              private translate: TranslateConfigService) { }

  ngOnInit() {}

  ionViewWillEnter(){
    this.scanQrWeb();
  }

  dismiss(value) {
    this.stop();
    this.modalCtrl.dismiss({confirm: value});
  }

  scanQrWeb(){
    this.video = <HTMLVideoElement>document.createElement("video");
    this.canvasElement = <HTMLCanvasElement>document.getElementById("canvas");
    this.canvas = this.canvasElement.getContext("2d");

    navigator.mediaDevices.getUserMedia({ video: { facingMode: "environment" } }).then((stream) => {
      this.video.srcObject = stream;
      //video.setAttribute("playsinline", true);
      this.video.play();
      if(!this.stopCamera){
        this.reqAnim = window.requestAnimationFrame(() => this.tick());
      }
    }).catch( async err => {
      const message = JSON.stringify(err);
      await FirebaseCrashlytics.recordException({message: message});
      await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleInfo'), await this.translate.getTranslate('MESSAGES.NotAllowedErrorCamera'),
      'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
    });
  }

  drawLine(begin, end, color) {
    this.canvas.beginPath();
    this.canvas.moveTo(begin.x, begin.y);
    this.canvas.lineTo(end.x, end.y);
    this.canvas.lineWidth = 4;
    this.canvas.strokeStyle = color;
    this.canvas.stroke();
  }

  tick() {
    if (this.video.readyState === this.video.HAVE_ENOUGH_DATA) {
      this.canvasElement.hidden = false;

      this.canvasElement.height = this.video.videoHeight;
      this.canvasElement.width = this.video.videoWidth;
      this.canvas.drawImage(this.video, 0, 0, this.canvasElement.width, this.canvasElement.height);
      var imageData = this.canvas.getImageData(0, 0, this.canvasElement.width, this.canvasElement.height);
      // var code = jsQR(imageData.data, imageData.width, imageData.height, {
      //   inversionAttempts: "dontInvert",
      // });
      // if (code != null && code.data !== '') {
      //   this.stop();
      //   this.drawLine(code.location.topLeftCorner, code.location.topRightCorner, "#FF3B58");
      //   this.drawLine(code.location.topRightCorner, code.location.bottomRightCorner, "#FF3B58");
      //   this.drawLine(code.location.bottomRightCorner, code.location.bottomLeftCorner, "#FF3B58");
      //   this.drawLine(code.location.bottomLeftCorner, code.location.topLeftCorner, "#FF3B58");
      //   this.modalCtrl.dismiss({ confirm: true, qr: code.data });
      //   return;
      // }
    }
    if(!this.stopCamera){
      this.reqAnim = window.requestAnimationFrame(() => this.tick());
    }
  }

  stop() {
    this.stopCamera = true;
    const mediaStream = <MediaStream>this.video.srcObject;
    if(mediaStream != null){
      const tracks = mediaStream.getTracks();
      tracks[0].stop();
    }
  }

}
